// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"108":"96133ef97be4f2fc1334","127":"74beb2b624dc2c358abc","245":"80c6a9651809730b3821","452":"c1af1f93c5a5e319d7ef"}[chunkId] + ".js";
};